/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
function e(e){return(s,r)=>{s.hasOwnProperty("_messageBundleProps")||(s._messageBundleProps=s._messageBundleProps?s._messageBundleProps.slice():[]);s._messageBundleProps.push({bundlePath:e,propertyName:r})}}export{e as messageBundle};
